import { removeSpacesStringUtil } from 'utils/string'

const USER_BEFORE_SAVE_HOOK = {
  birthday: value => new Date(value),
  name: value => value.toLowerCase(),
  // email  : value => value.toLowerCase(),
  lastName: value => removeSpacesStringUtil(value),
  firstName: value => removeSpacesStringUtil(value)
}

export {
  USER_BEFORE_SAVE_HOOK
}
